import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "../../auth/auth.service";
import { UserService } from "../../core/user/user.service";


@Component({
  selector: "platform-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnDestroy {
  isParentOrg = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly userService: UserService,
    private readonly authService: AuthService,
    private readonly changeDetector: ChangeDetectorRef
  ) {

  }
  ngOnInit() {
    this.isParentOrg = this.userService.getUserToken().isParentOrg;

    // This shell component is never destroyed on navigation, and account switching
    // no longer forces a full page reload, so it must refresh itself explicitly.
    this.authService.userTokenChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isParentOrg = this.userService.getUserToken().isParentOrg;
        this.changeDetector.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
